module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_5010.9a893846.png";